import { render, staticRenderFns } from "./ReservationCancellation.vue?vue&type=template&id=53c7a1c6"
import script from "./ReservationCancellation.vue?vue&type=script&lang=js"
export * from "./ReservationCancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports